

export const HANDLE_AXIOS_ERROR = (ERROR) => {

    // Puede ser por timeout, IP incorrecta (10.0.2.2 en Android) o falta de internet.
    if (ERROR?.code === "ERR_NETWORK" || ERROR?.message === "Network Error") {
        return {
            status: 503, data: null,
            message: "No se pudo conectar con el servidor. Verificá tu conexión o la IP del backend.",
        };
    }

    // 🔥 En Mobile, si no hay response, suele ser por Timeout o un error de SSL
    if (!ERROR.response) {
        return {
            status: 503, message: ERROR || "El servidor no respondió a la solicitud.", data: null
        };
    }

    const responseData = ERROR.response.data;
    let message = "Error en la solicitud.";

    if (responseData?.message) message = responseData.message;
    if (responseData?.msg) message = responseData.msg;

    if (Array.isArray(responseData?.errors)) {
        message = responseData.errors.join(" | ");
    }

    if (typeof responseData?.errors === "object" && !Array.isArray(responseData?.errors)) {
        message = Object.entries(responseData.errors).map(([field, msg]) => `${field}: ${msg}`).join(" | ");
    }

    return {
        status: ERROR.response.status, message: message, data: responseData
    };
};